import { useQueryClient } from '@tanstack/react-query';
import {
  ExternalLink,
  FileText,
  FolderGit2,
  LayoutDashboard,
  LogOut,
  UserRound,
} from 'lucide-react';
import { Link, NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { clearToken } from '../api/client';
import { cn } from '../lib/format';
import '../styles/admin.css';

const NAV_ITEMS = [
  { to: '/admin/dashboard', label: '仪表盘', icon: LayoutDashboard },
  { to: '/admin/posts', label: '文章管理', icon: FileText },
  { to: '/admin/projects', label: '项目管理', icon: FolderGit2 },
  { to: '/admin/profile', label: '个人资料', icon: UserRound },
];

const TITLES: Record<string, string> = {
  '/admin/dashboard': '仪表盘',
  '/admin/posts': '文章管理',
  '/admin/projects': '项目管理',
  '/admin/profile': '个人资料',
};

export default function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryClient = useQueryClient();

  const title =
    Object.entries(TITLES).find(([path]) => location.pathname.startsWith(path))?.[1] ?? '管理后台';

  const handleLogout = () => {
    clearToken();
    queryClient.clear();
    navigate('/admin/login', { replace: true });
  };

  return (
    <div className="admin-shell">
      <aside className="admin-sidebar">
        <Link to="/admin/dashboard" className="admin-brand">
          <img src="/favicon.png" alt="" aria-hidden="true" />
          <span>铁头功的博客 · 后台</span>
        </Link>

        <nav className="admin-nav" aria-label="后台导航">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                cn('admin-nav-link', isActive && 'admin-nav-link-active')
              }
            >
              <item.icon size={17} aria-hidden="true" />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="admin-sidebar-foot">
          <Link to="/" className="admin-nav-link" target="_blank">
            <ExternalLink size={16} aria-hidden="true" />
            <span>访问站点</span>
          </Link>
          <button type="button" className="admin-nav-link" onClick={handleLogout}>
            <LogOut size={16} aria-hidden="true" />
            <span>退出登录</span>
          </button>
        </div>
      </aside>

      <div className="admin-main">
        <header className="admin-topbar">
          <h1 className="admin-topbar-title">{title}</h1>
          <div className="admin-user">
            <span>管理员</span>
            <button type="button" className="btn btn-outline btn-sm" onClick={handleLogout}>
              退出
            </button>
          </div>
        </header>
        <div className="admin-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
